$ = require 'jquery'
{ assign, clone } = require 'lodash'

###
@dependsOn jquery
@dependsOn lodash
###
module.exports =
class XMLHttpRequest

  ###
  @private
  @property [Object] default options
  ###
  defOpts =
    timeout : 12000

  ###
  create XMLHttpRequest instance
  @param url [String] url
  @param opts [Object] options
  ###
  constructor: (url, opts) ->
    @opts = assign clone(defOpts), opts
    @opts.url  = url

  ###
  XML HTTP request
  ###
  request: ->
    dfd = $.Deferred()
    $.ajax @opts
      .done (data) =>
        @success data
        dfd.resolve data
      .fail (err) =>
        @failure err
        dfd.reject err
      .always =>
        @complete()
    dfd.promise()

  ###
  request success
  @param data [Object] request data
  ###
  success: (data) ->

  ###
  request failure
  @param err [Object] request error information
  ###
  failure: (err) ->

  ###
  request complete
  ###
  complete: ->



// WEBPACK FOOTER //
// ./webpack/requires/components/xml-http-request.coffee